import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  ToggleButtonProps
} from '@mui/material'
import { PowerUnit } from '../enums'
import { MouseEvent } from 'react'
import { Generator } from '../types'

export interface GeneratorAdditionalLoadUnitToggleButtonGroupProps extends Omit<
  ToggleButtonGroupProps,
  'value' | 'exclusive' | 'children'
> {
  generator?: Generator
  value: PowerUnit
  buttonProps?: Omit<ToggleButtonProps, 'value' | 'children'>
  onValueChange?: (value: PowerUnit) => void
}

export default function GeneratorAdditionalLoadUnitToggleButtonGroup({
  generator,
  value,
  onValueChange,
  onChange,
  buttonProps,
  ...props
}: GeneratorAdditionalLoadUnitToggleButtonGroupProps) {
  function handleChange(event: MouseEvent<HTMLElement>, newValue: PowerUnit) {
    onValueChange?.(newValue)
    onChange?.(event, newValue)
  }

  return (
    <ToggleButtonGroup value={value} exclusive onChange={handleChange} {...props}>
      <ToggleButton value={PowerUnit.KILOWATT} {...buttonProps}>
        kW
      </ToggleButton>
      <ToggleButton value={PowerUnit.AMPERE} {...buttonProps}>
        A
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
